import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useAuth } from "../../authentication";

function ProtectedRoute({ component: Component, ...restOfProps  }) {
  return (
    <Route
      {...restOfProps}
      render={(props) =>
        <Component {...props} />
      }
    />
  );
}

export default ProtectedRoute;